import { IconUser } from '@tabler/icons-react';
import Link from 'next/link';
import { Store } from '@/features/store/types';
interface SellerInfoProps {
  seller: Partial<Store>;
}
export const SellerInfo = ({
  seller
}: SellerInfoProps) => {
  return <div className="flex flex-col gap-4" data-sentry-component="SellerInfo" data-sentry-source-file="seller-info.tsx">
      <div className="flex items-center flex-row gap-2">
        <span className="h-8 w-8 inline-flex items-center justify-center rounded-full bg-primary">
          <span className="font-medium leading-none text-white">
            <IconUser size={18} data-sentry-element="IconUser" data-sentry-source-file="seller-info.tsx" />
          </span>
        </span>
        <div className="space-y-1">
          <Link className="text-md font-semibold hover:text-primary" href={`/${seller?.slug}`} data-sentry-element="Link" data-sentry-source-file="seller-info.tsx">
            @{seller?.slug}
          </Link>
        </div>
      </div>
    </div>;
};